/**
 * Formatiert eine IBAN in 4er-Blocks nach DIN ISO 13616.
 * Beispiel: "DE12345678901234567890" -> "DE12 3456 7890 1234 5678 90"
 * Robust gegen bereits-formatierte Inputs (entfernt Whitespace, re-formatiert).
 * Fallback bei leerer/null IBAN: Gibt leeren String zurueck.
 */
export function formatIban(iban: string | null | undefined): string {
    if (!iban) return "";
    const cleaned = String(iban).replace(/\s+/g, "").toUpperCase();
    if (cleaned.length === 0) return "";
    const groups: string[] = [];
    for (let i = 0; i < cleaned.length; i += 4) {
        groups.push(cleaned.slice(i, i + 4));
    }
    return groups.join(" ");
}
